import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { SpaCompletedModal } from "components";
import imageUrl from "utils/imageUrl";

const SpaSignModal = (props) => {
  const [modalShow, setModalShow] = useState(false);
  const [image, setImage] = useState(false);
  const handleModal = () => {
    props.onHide();

    setModalShow(true);
  };
  return (
    <>
      <Modal show={props.show} onHide={props.onHide}>
        <Modal.Header closeButton></Modal.Header>

        <div className="spa-modal-body modal-body space-y-20 pd-40">
          <h4 className="pb-3 text-center">Physical Signature</h4>

          <div className="hr"></div>
          <div className="img d-flex justify-content-center">
            <img
              src={imageUrl(image ? "signature.png" : "blank-image.jpg")}
              alt="congrats.png"
              width={"55%"}
              className={"spa-image"}
              onClick={() => setImage(true)}
            />
          </div>
          <div className="d-flex icon-main">
            <div className="icon d-flex flex-column justify-content-center text-center mx-2 my-1">
              <i className="fa-solid fa-download"></i>
              <span>Download</span>
            </div>
            <div className="icon d-flex flex-column justify-content-center text-center mx-2 my-1">
              <i className="fa-solid fa-print"></i>
              <span>Print</span>
            </div>
            <div className="icon d-flex flex-column justify-content-center text-center mx-2 my-1">
              <i className="fa-solid fa-share"></i>
              <span>Share</span>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <div>
              <Link
                to="/"
                className="btn btn-primary my-3"
                data-toggle="modal"
                data-target="#popup_bid_success"
                data-dismiss="modal"
                aria-label="Close"
                onClick={props.onHide}
              >
                {" "}
                Reset
              </Link>
            </div>
            <div>
              <button
                // to="#"
                className="btn btn-primary "
                data-toggle="modal"
                data-target="#popup_bid_success"
                data-dismiss="modal"
                aria-label="Close"
                onClick={handleModal}
                disabled={!image}
              >
                {" "}
                Submit Signature
              </button>
            </div>
            {/* <div>
              <button
                // to="#"
                className="btn btn-primary "
                data-toggle="modal"
                data-target="#popup_bid_success"
                data-dismiss="modal"
                aria-label="Close"
                onClick={handleModal}
                // disabled={!image}
              >
                {" "}
                reset
              </button>
            </div> */}
          </div>
        </div>
      </Modal>
      <SpaCompletedModal
        show={modalShow}
        onEnable={props.onEnable}
        onNext={props.onNext}
        onHide={() => setModalShow(!modalShow)}
      />
    </>
  );
};

export default SpaSignModal;
